/*
|-------------------------------------------------------------------------------
| API modules/users/users/index.js
|-------------------------------------------------------------------------------
| The Vuex data store for search
*/

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
